"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelMenu = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var label_menu_item_view_1 = require("../molecules/label-menu-item-view");
exports.LabelMenu = (0, react_1.memo)(function (_a) {
    var anchorEl = _a.anchorEl, onMenuClose = _a.onMenuClose, labels = _a.labels, labelSaturation = _a.labelSaturation, labelLightness = _a.labelLightness;
    var onClose = (0, react_1.useCallback)(function () {
        onMenuClose(undefined);
    }, [onMenuClose]);
    return (react_1.default.createElement(core_1.Menu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: onClose },
        react_1.default.createElement("div", null, labels.map(function (label) { return (react_1.default.createElement(label_menu_item_view_1.LabelMenuItemView, { key: label.id, onClick: onMenuClose, label: label, labelSaturation: labelSaturation, labelLightness: labelLightness })); }))));
});
exports.LabelMenu.displayName = 'LabelMenu';
